import React, { FC } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { greys, mainColors } from '../../../../../styling/theme';
import { BadgeOutlined } from '@mui/icons-material';
import { Modal, Tooltip } from '@mui/material';
import FastAPIInstance from '../../../../../services/risksystem3-public-api';

interface Props {
  user: any;
  reloadUsers: () => void;
}

const useStyles = makeStyles(() => ({
  deleteUserButton: {
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    gap: '0.62rem',
    padding: '0.31rem 0.62rem',
    borderRadius: '0.25rem',
    fontWeight: 400,
    border: `1px solid ${mainColors.mainBlue}`,
    color: mainColors.mainBlue,
    cursor: 'pointer',
    userSelect: 'none',
    '& svg': {
      fontSize: '1.00rem',
    },
    '&:hover': {
      backgroundColor: mainColors.mainBlue,
      color: 'white',
    },
    '&:active': {
      backgroundColor: mainColors.mainBlue_Darker,
      color: 'white',
    },
  },
  modalBackground: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalContentContainer: {
    backgroundColor: 'white',
    padding: '1.25rem',
    borderRadius: '0.25rem',
    border: `1px solid ${mainColors.mainBlue}`,
    width: '31.25rem',
  },
  modalTitle: {
    fontSize: '1.88rem',
    fontWeight: 600,
    color: mainColors.mainBlue,
  },
  modalContent: {
    fontSize: '1.25rem',
    fontWeight: 400,
    color: greys.grey700,
    display: 'flex',
    gap: '0.62rem',
    padding: '0.62rem 0',
  },
  username: {
    fontWeight: 600,
    color: greys.grey900,
  },
  modalActionContainer: {
    display: 'flex',
    gap: '0.62rem',
    alignItems: 'center',
    paddingTop: '0.62rem',
  },
  cancelButton: {
    all: 'unset',
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    gap: '0.62rem',
    padding: '0.31rem 1.25rem',
    borderRadius: '0.25rem',
    fontSize: '1.25rem',
    fontWeight: 400,
    backgroundColor: mainColors.mainBlue,
    color: 'white',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: mainColors.mainBlue_lighter,
    },
    '&:active': {
      backgroundColor: mainColors.mainBlue_Darker,
    },
  },
  deleteButton: {
    all: 'unset',
    width: 'fit-content',
    display: 'flex',
    flexDirection: 'row',
    gap: '0.62rem',
    padding: '0.31rem 1.25rem',
    borderRadius: '0.25rem',
    fontSize: '1.25rem',
    fontWeight: 400,
    backgroundColor: mainColors.Fail,
    color: 'white',
    cursor: 'pointer',
    userSelect: 'none',
    '&:hover': {
      backgroundColor: mainColors.Fail_darker,
    },
    '&:active': {
      backgroundColor: mainColors.Fail_even_darker,
    },
  },
  requestMessage: {
    fontSize: '0.88rem',
    fontWeight: 500,
    marginTop: '0.62rem',
  },
}));

const getAuthMessageColor = (authStatus: string): string => {
  switch (authStatus) {
    case 'success':
      return mainColors.Pass;
    case 'fail':
      return mainColors.Fail;
    default:
      return greys.grey600;
  }
};

const UserRoleConfirmation: FC<Props> = ({ user, reloadUsers }) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const [requestStatus, setRequestStatus] = React.useState<string>('');
  const [requestMessage, setRequestMessage] = React.useState<string>('');

  const handleUpdateRole = () => {
    setRequestStatus('loading');
    setRequestMessage('Sending request...');
    FastAPIInstance.put(`/v1/external_user_management/upgrade_user_type`, {
      user_id: user.user_id,
      user_type: user.user_type,
      user_last_updating_datetime: user.user_updating_datetime,
    })
      .then(() => {
        setRequestStatus('success');
        setRequestMessage('Updated Successfully.');
        reloadUsers();
        setTimeout(() => {
          setRequestStatus('idle');
          setRequestMessage('');
        }, 5000);
      })
      .catch(() => {
        setRequestStatus('fail');
        setRequestMessage('Unknown Error. Please contact RiskSystem support.');
      });
  };

  return (
    <>
      <Tooltip title="Upgrade To Administrator">
        <div onClick={() => setOpen(true)} className={classes.deleteUserButton}>
          <BadgeOutlined />
        </div>
      </Tooltip>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        className={classes.modalBackground}
      >
        <div className={classes.modalContentContainer}>
          <div className={classes.modalTitle}>Upgrade to administrator</div>
          <div className={classes.modalContent}>
            <div>User: </div>
            <div className={classes.username}>{user.user_name}</div>
          </div>
          <div className={classes.modalActionContainer}>
            <div
              className={classes.cancelButton}
              onClick={() => setOpen(false)}
            >
              Cancel
            </div>
            <div
              className={classes.deleteButton}
              onClick={() => handleUpdateRole()}
            >
              Upgrade User
            </div>
          </div>
          <div
            className={classes.requestMessage}
            style={{
              color: getAuthMessageColor(requestStatus),
            }}
          >
            {requestMessage}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UserRoleConfirmation;
